// extracted by mini-css-extract-plugin
module.exports = {"cardMobile":"styles_cardMobile__3Unj-"};